var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import Autosuggest from 'react-autosuggest';
import { DefaultSuggestions } from '../util';
export var AutocompleteRenderInput = function (_a) {
    var addTag = _a.addTag, props = __rest(_a, ["addTag"]);
    var handleOnChange = function (event, _a) {
        var method = _a.method;
        if (method === 'enter') {
            event.preventDefault();
        }
        else {
            props.onChange(event);
        }
    };
    var inputValue = (props.value && props.value.trim().toLowerCase()) || '';
    var inputLength = inputValue.length;
    var suggestions = DefaultSuggestions.filter(function (state) {
        return state.name.toLowerCase().slice(0, inputLength) === inputValue;
    });
    var shouldRender = function (props) {
        if (React.Children.count(props.children) > 0) {
            return (React.createElement("div", __assign({}, props.containerProps, { style: { flexDirection: 'row', width: '60rem' } }),
                React.createElement("div", { className: "flex-container" },
                    React.createElement("span", { className: "attributes-header" }, "Select Search Attribute"),
                    React.createElement("div", null, props.children /** This are the suggestions rendered by renderSuggestion */))));
        }
        else
            return (null);
    };
    var show = props.show, rest = __rest(props, ["show"]);
    return (React.createElement(Autosuggest, { ref: props.ref, suggestions: suggestions, shouldRenderSuggestions: function (value) { return !!show; }, alwaysRenderSuggestions: show, getSuggestionValue: function (suggestion) { return suggestion.name; }, renderSuggestionsContainer: function (props) {
            return shouldRender(props);
        }, renderSuggestion: function (suggestion) { return React.createElement("span", { className: 'suggestion' }, suggestion.name); }, inputProps: __assign(__assign({}, rest), { onChange: handleOnChange }), onSuggestionSelected: function (e, _a) {
            var suggestion = _a.suggestion;
            if (suggestion.name.endsWith(':')) {
                handleOnChange(__assign(__assign({}, e), { target: __assign(__assign({}, e.target), { value: suggestion.name + ' ' }) }), { method: 'type', newValue: suggestion.name + ' ' });
            }
            else {
                addTag(suggestion.name);
            }
        }, 
        // focusInputOnSuggestionClick alwaysRenderSuggestions /**  Just for debugging purposes */
        onSuggestionsClearRequested: function () {
        }, onSuggestionsFetchRequested: function () {
        } }));
};
//# sourceMappingURL=SearchAutocomplete.js.map